// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  useEmulators: false,
  production: false,
  version: "4.2.0",
  firebase: {
    // apiKey: 'AIzaSyBd_5WUN-rfl3XRU7GP_b13R3p-awmFRHM',
    // authDomain: 'pokedex-17801.firebaseapp.com',
    // databaseURL: 'https://pokedex-17801.firebaseio.com',
    // projectId: 'pokedex-17801',
    // storageBucket: 'pokedex-17801.appspot.com',
    // messagingSenderId: '324087404722',
    // appId: '1:324087404722:web:a618231c622f56bd'
    apiKey: "AIzaSyDhE3HJyIyE_dtvDEYDhYj9CqWrgynrisA",
    authDomain: "pdsgiv.firebaseapp.com",
    databaseURL: "https://pdsgiv.firebaseio.com",
    projectId: "pdsgiv",
    storageBucket: "pdsgiv.appspot.com",
    messagingSenderId: "624988011431",
    appId: "1:624988011431:web:f36835cfffaff216a79482",
    measurementId: "G-VEQZ07NGW8",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
